
import { Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export class UserManagementTab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["User", "Api"];
    }
}

export function UserManagementTab_$reflection() {
    return union_type("Settings.UserManagement.OverviewTabs.UserManagementTab", [], UserManagementTab, () => [[], []]);
}

export function UserManagementOverviewTabs(props) {
    let Label, Label_1;
    const t = useTranslation()[0];
    if (!props.RestEnabled) {
        return defaultOf();
    }
    else {
        return createElement(TabsMenu, {
            Tabs: ofArray([(Label = t("settings.user_management.overview.user"), {
                IsSelected: equals(props.SelectedTab, new UserManagementTab(0, [])),
                Label: Label,
                OnClick: () => {
                    RouterModule_nav(ofArray(["settings", "users"]), 1, 1);
                },
                TestId: "user-management-tab-user",
            }), (Label_1 = t("settings.user_management.overview.api"), {
                IsSelected: equals(props.SelectedTab, new UserManagementTab(1, [])),
                Label: Label_1,
                OnClick: () => {
                    RouterModule_nav(ofArray(["settings", "user-management", "api"]), 1, 1);
                },
                TestId: "user-management-tab-api",
            })]),
        });
    }
}

